import { render, staticRenderFns } from "./KnowledgePage.vue?vue&type=template&id=1871be2d"
import script from "./KnowledgePage.vue?vue&type=script&lang=js"
export * from "./KnowledgePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports